









import Component from 'vue-class-component'
import {Prop, Watch, Vue, Emit, Inject} from 'vue-property-decorator'


import {RefreshButton,Scrollable} from "../Common";
import PositionTable from "./PositionTable.vue";
import {EventBus, Messages, OrderBus, OrderMessages, PositionBus, PositionMessages} from "../../services/EventBus";
import TradingBlockRemote from "../../services/TradingBlockRemote";
import {ErrorCodeMap} from "../../domain/TbMaps";
import {extractJsonDate} from "../../utils/formatters";
import {AssetType, CharAssetType, Quote, Portfolio} from "../../domain/types";
import {Position} from "../../domain/Position";
import { fixUtcFormat } from '../../utils/vue_utils';

@Component({
    components: {PositionTable, RefreshButton, Scrollable}
})

class PositionBlock extends Vue{
        AccountNumber: string = '';
        summary:any = null;
        loading: boolean = false;
        loaded: boolean = false;
        response:any;
        xhr?:XMLHttpRequest;
        ErrorMessage:string=""; 
        @Prop()              
        portfolio: Portfolio;
        
        refresh () {
            PositionBus.$emit(<string>PositionMessages.PositionRefresh);
            this.load();
        }
        onLoad(){
            this.AccountNumber = TradingBlockRemote.AccountNumber;
            this.ErrorMessage = "";
            this.loading = false;
            this.loaded = true;
            this.ErrorMessage="";
        }
        onFailure(status:number){
            if (status>0)
                this.ErrorMessage = ErrorCodeMap[status];
            else
                this.ErrorMessage ="Server or network error: "+ Math.abs(status) + ". Please, report via email";
            this.summary = null;
            this.loading = false;
            this.loaded = false;
        }
        load(){
            this.loading = true;
            this.update();
        }
        loadOnShow(name:string){
            console.log('created')
            if (name == "#positionstab")
                this.load();
        }
        created(){
            console.log('created')
            this.load();               
        }
        beforeDestroy() {
            EventBus.$off(<string>Messages.TabChanged, this.loadOnShow);
        }
    tableData: any[]= [];
    update(){
        this.summary = null;
        new TradingBlockRemote({onComplete: async (response:any)=>{
               const positions:Position[] = response.d as Position[];
                if (positions.length === 0) {
                    this.ErrorMessage ="No positions found";
                    this.loading = false;
                    this.loaded = false;
                    return;
                }

                this.tableData = await this.getDataForTable(this.portfolio.id, positions);
                this.onLoad();
            },onFailure:(code:number)=>{
                this.onFailure(code);
            }}).GetPositions(this.portfolio.id);

    }

    async getDataForTable(id: number, positions: Position[]){
        try {
            const response = await TradingBlockRemote.getQuotesForPositions(id, positions.map((o:Position)=>o.Symbol));
            const quotes = response.d;
            if (!quotes || quotes.length==0) throw new Error("no quotes found for list of positions of " + positions.length);
            let totalCurrentValue = 0;
            let totalTotalCostBasis = 0;
            let totalUnrealizedGain = 0;
            let totalNetChange = 0;
            let i = -1;
            let tableContent :any[]= positions.map(function (e:Position) {
                i++;
                let quote = quotes.find(function (q:Quote) {
                    return q.Symbol === e.Symbol;
                });
                if (!quote) {
                    return {
                        Symbol: e.Symbol,
                        Description: e.Description,
                        AssetType: e.AssetType,

                        CostBasis: parseFloat(e.CostBasis!.toFixed(2)),
                        OpenQuantity: e.OpenQuantity,
                        N: i
                    }
                }
                let cur_val:number;
                if (e.AssetType === AssetType.Option) {
                    cur_val = e.OpenQuantity * quote.LastTradePrice! * e.OptionMultiplier!;
                    if (!e.Underlying) e.Underlying= e.Symbol.split(' ')[0];
                }else
                    cur_val = e.OpenQuantity * quote.LastTradePrice!;
                let total_cost = e.OpenQuantity * e.CostBasis!;

                totalCurrentValue += cur_val;
                totalTotalCostBasis += total_cost;
                totalUnrealizedGain += (cur_val - total_cost);
                totalNetChange += quote.NetChange;

                let o = <any>{
                    StrategyTypeId: e.StrategyTypeId,
                    GroupId: e.GroupId,
                    SubaccountId:e.SubaccountId,
                    AccountId: e.AccountId,
                    HasWorkingOpenOrder: e.HasWorkingOpenOrder,
                    HasWorkingCloseOrder: e.HasWorkingCloseOrder,

                    //NoOfLegs: e.NoOfLegs,
                    Commission: e.Commission,
                    OpenPrice: e.OpenPrice,
                    DateOpened:  null,
                    UnderlyingPrice: e.AssetType === AssetType.Option ? quote.UnderlyingPrice : quote.LastTradePrice,
                    Symbol: e.Symbol,
                    Description: quote.Description,
                    AssetType: e.AssetType,
                    Underlying: e.Underlying,
                    AskPrice: (quote.AskPrice != null) ? quote.AskPrice : "",
                    OpenQuantity: e.OpenQuantity,
                    //TotalCostBasis : total_cost.formatPrice() ,
                    CurrentValue: cur_val,
                    BidPrice: (quote.BidPrice != null) ? quote.BidPrice : "",
                    NetChange: (quote.NetChange != null) ? quote.NetChange : "",
                    N: i
                };
                if (e.DateOpened){
                    o.DateOpened=new Date(fixUtcFormat(e.DateOpened))
                }

                if (e.CostBasis){
                    o.CostBasis= parseFloat(e.CostBasis.toFixed(2));
                    let divider =  e.OptionMultiplier ? o.OpenQuantity * e.OptionMultiplier : o.OpenQuantity;
                    o.BasisPerShare = Math.sign(o.OpenQuantity) * e.CostBasis / divider;
                    o.UnrealizedGain= cur_val - e.CostBasis;
                }

                o.AccountId = e.AccountId;
                o.SubaccountId = e.SubaccountId;
                o.GroupId = e.GroupId;
                
                return o;
            });

            let footerContent = {
                DateOpened:"",
                Symbol:"",
                AssetType:"",
                UnderlyingPrice:"",
                //AskPrice:"Total:",
                //BidPrice:"",
                //CostBasis: "",
                OpenQuantity:"",
                //TotalCostBasis : totalTotalCostBasis.formatPrice() ,
                //CurrentValue: totalCurrentValue ,
                //UnrealizedGain: totalUnrealizedGain ,
                NetChange: totalNetChange
            };
            this.summary = <any>footerContent;
            //tableContent.push(footerContent);
            return tableContent;

        } catch (e) {
            console.error(e);
            throw new Error("Quotes api error");
        }

    }
}

export default PositionBlock;
